import { useState, useEffect } from 'preact/hooks';
import { validateRestrictedWords } from '../../product-customizer/utils';

function useRestrictedWords(text, isOnBlur, setIsOnBlur, enabled = true) {
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (enabled && isOnBlur) {
      validateRestrictedWords(text).then((response) => {
        setIsValid(response);
      });
      setIsOnBlur(false);
    } else {
      setIsValid(true);
    }
  }, [isOnBlur]);

  return isValid;
}

export default useRestrictedWords;
